import { html, TemplateResult } from 'lit';
import type { RoundtripStageContent } from '../types/roundtrip-stage-content.types.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export const renderIntro = (content: RoundtripStageContent): TemplateResult => {
    return html`
        <div class="der-tm-roundtrip-stage__header">
            <div class="der-tm-roundtrip-stage__header-title">
                <h1 class="page-title">${unsafeHTML(content.pageTitle)}</h1>
                <div class="component-title">${unsafeHTML(content.componentTitle)}</div>
            </div>
            <div class="der-tm-roundtrip-stage__header-intro">
                <div class="intro-title">${unsafeHTML(content.introTitle)}</div>
            </div>
        </div>
    `;
};
